import React from "react";

import Popconfirm, { PopconfirmProps } from "antd/lib/popconfirm";
import { DeleteOutlined } from "@ant-design/icons";

const EditInlineCardExtra: React.FC<
  Pick<PopconfirmProps, "onConfirm" | "onCancel"> & {
    entityName?: string;
    style?: React.CSSProperties;
  }
> = ({ onConfirm, onCancel, entityName = "Item", style }) => {
  return (
    <Popconfirm
      title={`Are you sure you want to delete this ${entityName}?`}
      onConfirm={onConfirm}
      onCancel={onCancel}
      okText="Yes"
      cancelText="No"
    >
      <DeleteOutlined
        style={{
          color: "red",
          ...style,
        }}
      />
    </Popconfirm>
  );
};

export default EditInlineCardExtra;
